var map = {
	"./0-1years.svg": "7aea",
	"./0-3years.svg": "98fe",
	"./4-7years.svg": "89b1",
	"./Cards.svg": "c882",
	"./Close.svg": "658e",
	"./Disponible-icon.svg": "c087",
	"./Episodios.svg": "58ea",
	"./Estrellita-Non-select.svg": "1c62",
	"./Estrellita.svg": "dfa5",
	"./PantallaPromo-01.svg": "95b9",
	"./Paypal-01.svg": "b614",
	"./Play.svg": "6706",
	"./Studio-icon-01.svg": "ac93",
	"./VerTrailer-icon-01.svg": "1025",
	"./VideoPromo-icon.svg": "20a1",
	"./VideoPromo.svg": "e14e",
	"./brocha.svg": "9e6f",
	"./brush-01.svg": "abd0",
	"./chevron-der.svg": "768d",
	"./chevron-derecho-1.svg": "f53f",
	"./chevron-izq.svg": "c6dd",
	"./chevron-izquierdo-1.svg": "c107",
	"./fondo_juegos.svg": "a6bf",
	"./fondo_newepisodios.svg": "5754",
	"./fondo_series.svg": "e730",
	"./juegos.svg": "d48e",
	"./wallpapers.svg": "9b01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a83";